import React from 'react';
import { Form, Image } from 'react-bootstrap';

const ProfileImageUpload = ({ preview, onChange }) => (
    <div className="p-2 border border-secondary rounded bg-dark">
        {preview ? (
            <Image src={preview} thumbnail fluid style={{maxHeight:'150px'}} className="mb-2 bg-dark border-0"/>
        ) : (
            <div className="text-white small py-4">No Image</div>
        )}
        <Form.Control type="file" size="sm" onChange={onChange} className="custom-form-input" style={{fontSize:'12px'}} />
    </div>
);

export default ProfileImageUpload;